var KayangAppSdk = {
    getAndroid: function () {
        return window.androidAttendance
    },
    getIOS: function () {
        return window.webkit.messageHandlers
    },
    showHeader: function (isHide) {
        if (isHide) {
            //todo 隐藏标题
        } else {
            if (this.getAndroid()) {
                this.getAndroid().protogenesisBack();
            } else {
                this.getIOS().iOSProtogenesisBack.postMessage(null)
            }
        }
    },
    // 调用app指纹、手势登录
    appAuthenticate: function () {
        if (this.getAndroid()) {
            this.getAndroid().authenticate();
        } else {
            var message = { msgId: 'KY_APP_IOS_Attendance' }
            this.getIOS().iOSAuthenticate.postMessage(message);
        }
    },
    // 配置app指纹、手势登录
    configAuthenticate: function () {
        if (this.getAndroid()) {
            this.getAndroid().configAuthenticate();
        } else {
            var message = { msgId: 'KY_APP_IOS_SSO_Code' };
            this.getIOS().iOSConfigAuthenticate.postMessage(message);
        }
    },
    //原生定位
    getNativeLoaction: function (onSuccess, onFail) {
        //iOS：原生层回传定位信息的方法：
        window.getLocationInfoiOS = function (latitude, longitude, adress) {
            var data = {
                lat: latitude,
                lng: longitude,
                adress: adress,
            }
            clearTimeout(timeout);
            onSuccess(data)
        }
        window.getLocationInfoAndroid = function getLocationInfoAndroid(json) {
            var data = {
                lat: json.lat,
                lng: json.lng,
                adress: json.adress,
            }
            clearTimeout(timeout);
            onSuccess(data)
        }

        if (this.getAndroid()) {
            //Android：H5发起原生定位的方法：
            this.getAndroid().protogLoction();
        } else {
            //iOS：H5发起原生定位的方法：
            this.getIOS().iOSBMKLoction.postMessage(null);
        }
        var timeout = setTimeout(function () {
            onFail('timeout');
        }, 30000)
    },
    attendance: function (locateStyle) {

        if (locateStyle == 1) {
            //原生百度定位
            if (this.getAndroid()) {
                this.getAndroid().locateSuccess();
            } else {
                this.getIOS().iOSAttendance.postMessage(null);
            }
        } else {
            //原生高德定位
            if (this.getAndroid()) {
                this.getAndroid().AndroidGaoDeAttendance();
            } else {
                this.getIOS().iOSGaoDeAttendance.postMessage(null);
            }
        }
    },
    callNative: function (method, onSuccess, onFail) {
        var timeout = setTimeout(function () {
            onFail('timeout');
        }, 60000);

        _nativeMethods[method] = {
            onSuccess: onSuccess,
            onFail: onFail,
            timeout: timeout
        }

        var msg = { method: method, };
        if (this.getAndroid()) {
            this.getAndroid().callNative(msg);
        } else {
            this.getIOS().callNative.postMessage(msg);
        }
    },
    scanQrCodeGo() {
        if (this.getAndroid()) {
            this.getAndroid().scanCode();
        } else {
            var message = { msgId: 'KY_APP_IOS_Scan_Code' };
            this.getIOS().iOSScanCode.postMessage(message);
        }
    },

}

var _nativeMethods = {};

window.onNativeCallbackiOS = function (method, data) {
    clearTimeout(_nativeMethods[method].timeout);
    _nativeMethods[method].onSuccess(data)
}

window.onNativeCallbackAndroid = function (json) {
    var data = json.data;
    var method = json.method;
    clearTimeout(_nativeMethods[method].timeout);
    _nativeMethods[method].onSuccess(data)
}

export default KayangAppSdk
